import { VpIcon } from '@vtmn-play/react';
import { getWeek } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { SpoSmSheetResponse } from '@spo/types';
import { SmInfoContainer } from '../SmInfoContainer';
import { SmInfoDisplay } from '../smInfoDisplay';
import './smMainInfos.scss';

const DateDisplay = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  return (
    <>
      {`W${getWeek(new Date(startDate), { weekStartsOn: 1 })} ${startDate}`}
      <span className="sm-info-date-separator">to</span>
      {`W${getWeek(new Date(endDate), { weekStartsOn: 1 })} ${endDate}`}
    </>
  );
};

export interface SmMainInfosProps {
  sm: SpoSmSheetResponse | undefined;
  isLoading: boolean;
}

export const SmMainInfos = ({ sm, isLoading }: SmMainInfosProps) => {
  const { t } = useTranslation();
  return (
    <SmInfoContainer
      title={t('sm-info.main-informations')}
      icon={<VpIcon name="t-shirt" />}
    >
      <SmInfoDisplay label={t('sm-info.label')} isLoading={isLoading}>
        {sm?.descriptionEn}
      </SmInfoDisplay>
      <div className="sm-info-main-line">
        <SmInfoDisplay label={t('sm-info.code')} isLoading={isLoading} copyTool>
          {sm?.id}
        </SmInfoDisplay>
        <SmInfoDisplay
          label={t('sm-info.conception-code')}
          isLoading={isLoading}
          copyTool
        >
          {sm?.conceptionCode}
        </SmInfoDisplay>
      </div>
      <SmInfoDisplay label={t('sm-info.availability')} isLoading={isLoading}>
        {sm?.startDate && sm?.endDate && (
          <DateDisplay startDate={sm?.startDate} endDate={sm?.endDate} />
        )}
      </SmInfoDisplay>
      <SmInfoDisplay label={t('sm-info.seasonality')} isLoading={isLoading}>
        {sm?.seasonality}
      </SmInfoDisplay>
    </SmInfoContainer>
  );
};
